import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/ClinicalOperations`;

/**
 * Actualiza el status de una observación existente.
 * No se puede modificar una observación con status `deleted` (25).
 *
 * @param {Object} updateData
 * @param {number} updateData.observationId - ID de la observación
 * @param {number} updateData.newStatus - Nuevo status (23=Open, 24=Closed, 25=Deleted)
 * @param {number} [updateData.employeeId] - Empleado que realiza el cambio
 *
 * Ejemplo de llamada:
 * PUT /api/ClinicalOperations/observations-v2/update-status
 * Body: { "observationId": 157, "newStatus": 24, "employeeId": 42 }
 *
 * Respuesta exitosa (200):
 * { "result": 0, "message": "Observation status updated successfully" }
 *
 * Posibles errores (400):
 * { "result": 1, "message": "Observation not found" }
 * { "result": 1, "message": "Cannot modify a deleted observation" }
 * { "result": 1, "message": "Invalid status for observations" }
 */
const updateObservationStatus = async (updateData) => {
  try {
    const response = await axios.put(`${API_URL}/observations-v2/update-status`, updateData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating observation status:", error);
    throw error;
  }
};

export default updateObservationStatus;
